export class Contacts {
    name: string;
    email: string;
    phone: string;
    subject: string;
    message: string = "";
}